module.exports = __webpack_public_path__ + "06277425.png";


//////////////////
// WEBPACK FOOTER
// ./public/icons/scroll-up.png
// module id = 1316
// module chunks = 8